const isNumber = (str: string) => !isNaN(Number(str));

export default isNumber;
